var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { customElement } from '../Internals';
import { svg } from 'lit/static-html.js';
let PICDrawLoading = class PICDrawLoading extends LitElement {
    constructor() {
        super(...arguments);
        this.loadingText = 'Loading Page';
    }
    render() {
        return svg `
    <svg id="pic-LoadingIcon1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" height="100%" width="100%">
      <path fill="black" d="M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3  c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z">
        <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="2s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform>
      </path>
      <path fill="black" d="M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7  c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z">
        <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="-360 50 50" repeatCount="indefinite"></animateTransform>
      </path>
      <path fill="black" d="M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5  L82,35.7z">
        <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="2s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform>
      </path>
      <text id="loadingtxt" font-size=".9230769231em" y="50">${this.loadingText}<animate attributeName="fill" attributeType="xml" id="loading1" begin="0;loading2.end" dur="1s" from="white" to="black" itteration-count="infinite"></animate>
        <animate attributeName="fill" attributeType="xml" id="loading2" begin="loading1.end" dur="1s" from="black" to="white" itteration-count="infinite"></animate>
      </text>
    </svg>    
  `;
    }
};
__decorate([
    property()
], PICDrawLoading.prototype, "loadingText", void 0);
PICDrawLoading = __decorate([
    customElement('pic-drawloadingscreen')
], PICDrawLoading);
export { PICDrawLoading };
let PICDrawProfile = class PICDrawProfile extends LitElement {
    // const strokeWidth = "20";
    // const SVG = document.getElementById("SVG");
    // createPencil() {
    //     let pencilCoordinates;
    //     let pencilVelocity;
    //     let pencilInUse;
    //     window.addEventListener("mousemove", function(e) {
    //         const rect = SVG.getBoundingClientRect();
    //         nextPencilCoordinates = {
    //             x: e.pageX - rect.left,
    //             y: e.pageY - rect.top
    //         };
    //         if(!pencilCoordinates) {
    //           pencilCoordinates = nextPencilCoordinates;
    //         }
    //         const pencilXDelta = nextPencilCoordinates.x - pencilCoordinates.x;
    //         const pencilYDelta = nextPencilCoordinates.y - pencilCoordinates.y;
    //         pencilVelocity = Math.sqrt(Math.pow(pencilXDelta,2)+Math.pow(pencilYDelta,2));
    //         pencilCoordinates = nextPencilCoordinates;
    //     })
    //     window.addEventListener("touchmove", function(e) {
    //         const rect = SVG.getBoundingClientRect();
    //         nextPencilCoordinates = {
    //             x: e.clientX||e.touches[0].clientX - rect.left,
    //             y: e.clientY||e.touches[0].clientY - rect.top
    //         };
    //         if(!pencilCoordinates) {
    //             pencilCoordinates = nextPencilCoordinates;
    //         }
    //         const pencilXDelta = nextPencilCoordinates.x - pencilCoordinates.x;
    //         const pencilYDelta = nextPencilCoordinates.y - pencilCoordinates.y;
    //         pencilVelocity = Math.sqrt(Math.pow(pencilXDelta,2)+Math.pow(pencilYDelta,2));
    //         pencilCoordinates = nextPencilCoordinates;
    //     })
    //     return {
    //         getPencilCoordinates: function() {
    //             return pencilCoordinates;
    //         },
    //         getPencilVelocity: function() {
    //             return pencilVelocity;
    //         },
    //         getPencilRefreshRate: function() {
    //             const invVelocity = 1 / ((pencilVelocity > 1) ? pencilVelocity : 1);
    //             const refreshRate = invVelocity * 80 * (strokeWidth / 50);
    //             // above computation can definitely be improved
    //             return refreshRate;
    //         },
    //         isPencilUsed: function() {
    //             return pencilInUse;
    //         },
    //         usePencil: function() {
    //             pencilInUse = true;
    //         },
    //         leavePencil: function() {
    //             pencilInUse = false;
    //             pencilCoordinates = undefined;
    //         }
    //     }
    // }
    // createPath() {
    //     const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    //     const pencilCoordinates = pencil.getPencilCoordinates();
    //     path.setAttribute("fill","none");
    //     path.setAttribute("stroke","#000");
    //     path.setAttribute("stroke-width", this.strokeWidth);
    //     path.setAttribute("d","M"+pencilCoordinates.x+" "+pencilCoordinates.y);
    //     SVG.appendChild(path);
    //     return path;
    // }
    // completePath(path) {
    //     const pencilCoordinates = pencil.getPencilCoordinates();
    //     let d = path.getAttribute("d");
    //     d += " L"+pencilCoordinates.x+" "+pencilCoordinates.y;
    //     path.setAttribute("d",d);
    //     const pencilRefreshRate = pencil.getPencilRefreshRate();
    //     if(pencil.isPencilUsed()) {
    //         setTimeout(completePath, pencilRefreshRate, path);
    //     }
    // }
    // const pencil = createPencil();
    // SVG.addEventListener("mousedown", function(){
    //     const path = createPath();
    //     const pencilRefreshRate = pencil.getPencilRefreshRate();
    //     pencil.usePencil();
    //     pencilTimemout = setTimeout(completePath, pencilRefreshRate, path)
    // });
    // SVG.addEventListener("mouseup", function(){
    //     pencil.leavePencil();
    // });
    // SVG.addEventListener("touchstart", function(){
    //     setTimeout(function() {
    //       const path = createPath();
    //       const pencilRefreshRate = pencil.getPencilRefreshRate();
    //       pencil.usePencil();
    //       pencilTimemout = setTimeout(completePath, pencilRefreshRate, path)
    //     }, 100);    
    // });
    // SVG.addEventListener("touchend", function(){
    //     pencil.leavePencil();
    // });  
    render() {
        return html `
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern
            id="smallGrid"
            width="8"
            height="8"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 8 0 L 0 0 0 8"
              fill="none"
              stroke="gray"
              stroke-width="0.5"
            />
          </pattern>
          <pattern
            id="grid"
            width="80"
            height="80"
            patternUnits="userSpaceOnUse"
          >
            <rect width="80" height="80" fill="url(#smallGrid)" />
            <path
              d="M 80 0 L 0 0 0 80"
              fill="none"
              stroke="gray"
              stroke-width="1"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>
    `;
    }
    /*<span class=${classMap(this.getTextClass())}> Logout </span>*/
    /*${this.loady()}*/
    picDotsLoading(parentNode, scale) {
        let svgNS = 'http://www.w3.org/2000/svg';
        let dotsSvg = document.createElementNS(svgNS, 'svg');
        if (scale) {
            dotsSvg.setAttribute('viewBox', '0 0 40 80');
            dotsSvg.setAttribute('width', scale / 2 + 'em');
            dotsSvg.setAttribute('height', scale + 'em');
        }
        else {
            dotsSvg.setAttribute('width', '80');
            dotsSvg.setAttribute('height', '190');
        }
        dotsSvg.setAttribute('xmlns', svgNS);
        dotsSvg.setAttribute('id', 'loadingIcon');
        dotsSvg.setAttribute('version', '1.1');
        let g1 = document.createElementNS(svgNS, 'g');
        g1.setAttributeNS(null, 'id', 'main');
        if (scale)
            g1.setAttributeNS(null, 'transform', 'scale(' + scale + ')');
        let g2 = document.createElementNS(svgNS, 'g');
        g2.setAttributeNS(null, 'id', 'square_group');
        g2.setAttributeNS(null, 'transform', 'translate(5,0)');
        let path1 = document.createElementNS(svgNS, 'path');
        path1.setAttributeNS(null, 'id', 'redsquare');
        path1.setAttributeNS(null, 'class', 'redani');
        path1.setAttributeNS(null, 'fill', '#E81D2B');
        path1.setAttributeNS(null, 'd', 'M 0,0 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z ');
        let animate1 = document.createElementNS(svgNS, 'animate');
        animate1.setAttributeNS(null, 'id', 'redAni');
        animate1.setAttributeNS(null, 'attributeName', 'opacity');
        animate1.setAttributeNS(null, 'dur', '3s');
        animate1.setAttributeNS(null, 'values', '1;0;1');
        animate1.setAttributeNS(null, 'begin', '0s;blueAni.end + 1s');
        path1.appendChild(animate1);
        let path2 = document.createElementNS(svgNS, 'path');
        path2.setAttributeNS(null, 'id', 'yellowsquare');
        path2.setAttributeNS(null, 'class', 'yellowani');
        path2.setAttributeNS(null, 'fill', '#FFD939');
        path2.setAttributeNS(null, 'd', 'M 0,10 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z ');
        let animate2 = document.createElementNS(svgNS, 'animate');
        animate2.setAttributeNS(null, 'id', 'yellowAni');
        animate2.setAttributeNS(null, 'attributeName', 'opacity');
        animate2.setAttributeNS(null, 'dur', '3s');
        animate2.setAttributeNS(null, 'values', '1;0;1');
        animate2.setAttributeNS(null, 'begin', 'redAni.begin + 0.5s');
        path2.appendChild(animate2);
        let path3 = document.createElementNS(svgNS, 'path');
        path3.setAttributeNS(null, 'id', 'greensqaure');
        path3.setAttributeNS(null, 'class', 'greenani');
        path3.setAttributeNS(null, 'fill', '#37AD4C');
        path3.setAttributeNS(null, 'd', 'M 0,20 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z ');
        let animate3 = document.createElementNS(svgNS, 'animate');
        animate3.setAttributeNS(null, 'id', 'greenAni');
        animate3.setAttributeNS(null, 'attributeName', 'opacity');
        animate3.setAttributeNS(null, 'dur', '3s');
        animate3.setAttributeNS(null, 'values', '1;0;1');
        animate3.setAttributeNS(null, 'begin', 'yellowAni.begin + 0.5s');
        path3.appendChild(animate3);
        let path4 = document.createElementNS(svgNS, 'path');
        path4.setAttributeNS(null, 'id', 'bluesquare');
        path4.setAttributeNS(null, 'class', 'blueani');
        path4.setAttributeNS(null, 'fill', '#007CB4');
        path4.setAttributeNS(null, 'd', 'M 0,30 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z ');
        let animate4 = document.createElementNS(svgNS, 'animate');
        animate4.setAttributeNS(null, 'id', 'blueAni');
        animate4.setAttributeNS(null, 'attributeName', 'opacity');
        animate4.setAttributeNS(null, 'dur', '3s');
        animate4.setAttributeNS(null, 'values', '1;0;1');
        animate4.setAttributeNS(null, 'begin', 'greenAni.begin + 0.5s');
        path4.appendChild(animate4);
        g2.appendChild(path1);
        g2.appendChild(path2);
        g2.appendChild(path3);
        g2.appendChild(path4);
        g1.appendChild(g2);
        dotsSvg.appendChild(g1);
        parentNode.appendChild(dotsSvg);
        return html `${dotsSvg}`;
    }
    loady() {
        return html `<svg
      viewBox="0 0 40 80"
      width="4em"
      height="8em"
      xmlns="http://www.w3.org/2000/svg"
      id="loadingIcon"
      version="1.1"
      style="visibility: vissible; vertical-align: middle;"
    >
      <g id="main" transform="scale(2)">
        <g id="square_group" transform="translate(5,0)">
          <path
            id="redsquare"
            class="redani"
            fill="#E81D2B"
            d="M 0,0 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "
          >
            <animate
              id="redAni"
              attributeName="opacity"
              dur="3s"
              values="1;0;1"
              begin="0s;blueAni.end + 1s"
            ></animate>
          </path>
          <path
            id="yellowsquare"
            class="yellowani"
            fill="#FFD939"
            d="M 0,10 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "
          >
            <animate
              id="yellowAni"
              attributeName="opacity"
              dur="3s"
              values="1;0;1"
              begin="redAni.begin + 0.5s"
            ></animate>
          </path>
          <path
            id="greensqaure"
            class="greenani"
            fill="#37AD4C"
            d="M 0,20 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "
          >
            <animate
              id="greenAni"
              attributeName="opacity"
              dur="3s"
              values="1;0;1"
              begin="yellowAni.begin + 0.5s"
            ></animate>
          </path>
          <path
            id="bluesquare"
            class="blueani"
            fill="#007CB4"
            d="M 0,30 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "
          >
            <animate
              id="blueAni"
              attributeName="opacity"
              dur="3s"
              values="1;0;1"
              begin="greenAni.begin + 0.5s"
            ></animate>
          </path>
        </g>
      </g>
    </svg>`;
    }
};
PICDrawProfile = __decorate([
    customElement('pic-drawprofile')
], PICDrawProfile);
export { PICDrawProfile };
//# sourceMappingURL=PICDrawings.js.map